import { createFileRoute } from '@tanstack/react-router'
import { ProcessFlowsHomepage } from 'pages/processFlows/ProcessFlowsHomepage'
import { processFlowsSearchParams } from 'routes/process-flows/-searchParams'

const RouteComponent = () => {
  const { orgId, siteId } = Route.useSearch()

  return <ProcessFlowsHomepage orgId={orgId} siteId={siteId} />
}

export const Route = createFileRoute('/process-flows/')({
  component: RouteComponent,
  validateSearch: processFlowsSearchParams,
  staticData: {
    title: 'Process Flows',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: true,
    },
  },
})
